import axios from 'axios'
import config from '../config'
import {getDoctorToken} from '../utils'

const updatePatientDetailApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}patient/${params.id}`,
        method: "patch",
        data:params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getDoctorToken()}`
        }
    })

    return response

}

export default updatePatientDetailApi